import React from 'react';
import '../../styles/elements/screen.scss';


class ScreenComponent extends React.Component {
    getStyle() {
        return {
            display: this.props.view === this.getScreenName() ? 'block' : 'none'
        }
    }

    getClass() {
        let className = 'screen screen-' + this.getScreenName();

        if (this.props.view === this.getScreenName()) {
            className += ' opened';
        }

        return className;
    }

    getScreenName() {
        return null;
    }
}

export default ScreenComponent;
